// Keep in sync with app/lib/enums/l4_category_sort_field.py
const L4CategorySortField = {
  PRODUCT_COUNT: 'product_count',
  L90D_GMV: 'l90d_gmv',
};

export default L4CategorySortField;
